import Vue from "vue";
import App from "./App.vue";
import VueLazyLoad from "vue-lazyload";
import i18n from "./i18n";
import store from "./store";
import router from "./router";
import VueRouter from "vue-router";
import device from "vue-device-detector";
import "./assets/css/tailwind.css";
import "./assets/css/main.css";

Vue.config.productionTip = false;

Vue.use(device);
Vue.use(VueRouter);
Vue.use(VueLazyLoad);
new Vue({ i18n, router, store, render: h => h(App) }).$mount("#app");
